import { Link } from 'gatsby';
import tw, { styled } from 'twin.macro';

export const AnchorHeadingWrapper = styled.h2`
  ${tw`flex items-center relative`}
  ${tw`font-bold`}
  & > a {
    ${tw`invisible`}
  }
  &:hover a {
    ${tw`visible`}
  }
`;

export const AnchorLink = styled(Link)`
  ${tw`text-neutrals-n9`}
`;

export const AnchorIcon = styled.svg<{ type: string }>`
  ${tw`inline-block ml-[10px] mt-[-1px]`}
  ${tw`fill-neutrals-n7 hover:fill-primary-p1`}
  ${({ type }) => (type === 'h2' || type === 'h3') && tw`ml-[14px]`}
  ${({ type }) => (type === 'h1' || type === 'h5') && tw`w-[16px] h-[16px] mt-[-2px]`}
  ${({ type }) => (type === 'h4' || type === 'h6') && tw`w-[20px] h-[20px] mt-[-2px]`}
`;

// NOTE We offset the anchor link ID to account for the fixed header overlapping the targetted header
// NOTE Relevant StackOverflow post: https://stackoverflow.com/questions/4086107/fixed-page-header-overlaps-in-page-anchors
export const AnchorOffset = styled.span`
  ${tw`absolute top-[-150px]`};
`;
